module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-metals-remnants.f7509095.png";